import { BundledAuctionPage as BundledAuction } from '#src/components/auction/BundledAuctionPage/index.tsx';

const BundledAuctionPage = () => {
  return <BundledAuction />;
};
export default BundledAuctionPage;
